module.exports = __webpack_public_path__ + "img/flag_es.1025bd5b.jpg";